export class ReportsTypes {
    Id: number;
    Name: string;
    Brief: string;
    PrintTemplate: string;
    SendTemplate: string;
    createdAt: Date;
    updatedAt: Date;
}